// Recursively redacts values of keys that may carry PII / PHI before an HTTP
// response body is sent to telemetry (Sentry, Flutter/logcat). This is a
// healthcare app — backend bodies can echo patient data subject to GDPR /
// health-data protection. We redact by KEY name (not value) so the structure
// and field identity survive for debugging while the sensitive value is dropped:
//   { errors: { email: ['x'] } }  ->  { errors: { email: '[redacted]' } }
// Generic keys (message, error, code, correlationId, status, ...) pass through.

const SENSITIVE_KEY_PATTERNS = [
  'email',
  'phone',
  'firstname',
  'lastname',
  'surname',
  'fullname',
  'birth',
  'address',
  'street',
  'city',
  'zip',
  'postal',
  'answer',
  'insurance',
  'password',
  'token',
  'patient',
  'ssn',
  'rodne'
];

const REDACTED = '[redacted]';
const MAX_DEPTH = 6;

const isSensitiveKey = key =>
  typeof key === 'string' &&
  SENSITIVE_KEY_PATTERNS.some(pattern => key.toLowerCase().includes(pattern));

export const redactPii = (value, depth = 0) => {
  // Fail-closed: past the depth limit we can no longer inspect keys, so redact
  // rather than risk leaking a sensitive value from deeper in the tree.
  if (depth > MAX_DEPTH) {
    return REDACTED;
  }

  if (value === null || typeof value !== 'object') {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(item => redactPii(item, depth + 1));
  }

  const output = {};
  for (const [key, val] of Object.entries(value)) {
    output[key] = isSensitiveKey(key) ? REDACTED : redactPii(val, depth + 1);
  }
  return output;
};

export default redactPii;
